import { ProUserFilters } from './ProUserSearchForm';
import { RepUserFilters } from './RepUserSearchForm';

export const proFiltersToQueryParams = (filters: ProUserFilters) => {
  return {
    corporate_client: filters.corporateClient?.join(';') ?? null,
    cohort: filters.cohort?.join(';') ?? null,
    application_status: filters.applicationStatus?.join(';') ?? null,
    timezone: filters.timezone?.join(';') ?? null,
    match_status: filters.matchStatus ?? null,
    max_introductions: filters.maxIntroductions ?? null,
    search_status: filters.searchStatus?.join(';') ?? null,
    requested_cohort_notifications: filters.requestedCohortNotifications ?? null,
  };
};

export const repFiltersToQueryParams = (filters: RepUserFilters) => {
  return {
    timezone: filters.timezone ? filters.timezone.join(';') : null,
    application_status: filters.applicationStatus ? filters.applicationStatus.join(';') : null,
    corporate_client: filters.corporateClient ? filters.corporateClient.join(';') : null,
    // we have duplicate partners currently in prod database, example WeConnect.
    // multi select currently uses label as key, so we need to add a unique value to each option label
    // and remove it before sending to backend
    impact_partner:
      filters.impactPartner ?
        filters.impactPartner.map((partner) => partner.split(' [id:')[0]).join(';')
      : null,
    cohort_matches: filters.cohortMatches ? filters.cohortMatches.join(';') : null,
    has_published: filters.hasPublished ? filters.hasPublished : null,
    match_status: filters.matchStatus ? filters.matchStatus : null,
    has_published_unmatched: filters.hasPublishedUnmatched,
  };
};
